import { RootState } from '@store/rootReducer'

export const selectHealthStatus = (state: RootState) => state.health.healthStatus
export const selectHealthStatusLoading = (state: RootState) =>
  state.health.getHealthStatusReq.loading
export const selectHealthStatusError = (state: RootState) => state.health.getHealthStatusReq.error
